import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Release } from "@typings/entities/releases";

async function getReleaseById(id: string): Promise<Release> {
  const response = await apiClient.get<Release>(apiPaths.releases.getById(id));
  return response.data;
}

export function useGetReleaseById(
  releaseId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    releaseId ? [`fetch-release-${releaseId}`] : null,
    () => getReleaseById(releaseId!),
    options,
  );
}
